import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import close from '../Components/Images/x-close.png';
import user from '../Components/Images/user.png';
import { Context } from '../Context/Context'
import Select from 'react-select';
import Bank from '../Components/Images/bank.svg';
import currencyCountryMap from './CurrencyCountryMap ';
// import SouthAfrica from '../Components/Images/SouthAfrica.png';
// import UK from '../Components/Images/UK.png';
// import USA from '../Components/Images/USA.png';
import Nigeria from '../Components/Images/Nigeria.png';
// import Philippines from '../Components/Images/Philippines.png';
// import India from '../Components/Images/India.png';
// import BeneficiaryModal from './BeneficiaryModal';
// import countries from './Countries';

function generateLabel(field) {
    const lastSegment = field.split('.').pop(); // e.g., 'phone'

    // Handle known replacements
    const specialLabels = {
        phone: 'Phone Number',
        iban: 'IBAN Number',
        email: 'Email Address',
        dob: 'Date of Birth',
        ssn: 'SSN',
    };

    if (specialLabels[lastSegment.toLowerCase()]) {
        return specialLabels[lastSegment.toLowerCase()];
    }

    // Default: convert camelCase or snake_case to Title Case
    return lastSegment
        .replace(/([A-Z])/g, ' $1')     // camelCase → space before capital
        .replace(/_/g, ' ')             // snake_case → spaces
        .replace(/\b\w/g, (l) => l.toUpperCase()); // capitalize each word
}

const BeneficiaryBar = ({ setOpenBenModal, setErrorModal }) => {
    const { handleBeneficiaryBar, beneficiaryBar, handleAddedBeneficiaries, initialFormData, formData, setFormData, banks, setBanks, uniqueFields, setUniqueFields, fetchBeneficiaries } = useContext(Context)
    const [method, setMethod] = useState('bank')
    const [errors, setErrors] = useState({});

    const [selectedCountry, setSelectedCountry] = useState(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [load, setLoad] = useState(false);
    const [banksFetched, setBanksFetched] = useState(false);

    const uniqueFieldRefs = useRef({});

    const fieldRefs = {
        full_name: useRef(null),
        stateOrProvince: useRef(null),
        city: useRef(null),
        streetLine1: useRef(null),
        bank_name: useRef(null),
        bankAcctType: useRef(null),
        selectedCurrency: useRef(null),
        selectedCountry: useRef(null),
        networkType: useRef(null),
        acctType: useRef(null),
        crypto: useRef(null),
        wallet_address: useRef(null),
    };

    const initialFormDataCrypto = {
        cryptocurrency_type: 'USDC',
        wallet_address: '',
        network_type: '',
        full_name: '',
        account_type: 'crypto'
    };

    const [formDataCrypto, setFormDataCrypto] = useState(initialFormDataCrypto);
    const [fullNameError, setFullNameError] = useState('');

    const fieldMappingOverrides = {
        'bank.phone': 'phone_number',
        'accountHolder.phone': 'phone_number',
        'bank.accountNumber': 'account_number',
        'bank.nubanCode': 'nuban_code',
        // add more if needed
    };

    const toSnakeCase = (str) =>
        str
            .replace(/([A-Z])/g, '_$1') // camelCase → snake_case
            .replace(/\./g, '')         // remove dot (optional, for cleaner names)
            .toLowerCase();

    const extractFieldKey = (field) => {
        if (fieldMappingOverrides[field]) {
            return fieldMappingOverrides[field]; // use override if exists
        }

        const lastSegment = field.split('.').pop(); // e.g. 'phone'
        return toSnakeCase(lastSegment); // fallback
    };

    const handleBankChange = (e) => {
        const { name, value } = e.target;

        // Check for full name validation
        if (name === 'full_name') {
            const wordCount = value.trim().split(/\s+/).length;
            if (wordCount < 2) {
                setFullNameError('Please enter your first name and last name');
            } else {
                setFullNameError('');
            }
        }

        let newValue = value;
        if (name === 'account_number') {
            // Remove all non-digit characters
            newValue = value.replace(/\D/g, '');
        }

        setFormData(prev => ({ ...prev, [name]: newValue }));
        setErrors(prev => ({
            ...prev,
            [name]: '',
        }));
    };


    const handleBankChange2 = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            bank_name: selectedOption?.value || '',
            bank_code: selectedOption?.code || ''
        }));
        setErrors(prev => ({
            ...prev,
            bank_name: ''
        }));
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        setErrors(prev => ({
            ...prev,
            [field]: ''
        }));
    };

    const handleCryptoChange = (e) => {
        setFormDataCrypto(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
        setErrors(prev => ({
            ...prev,
            [e.target.name]: '', // clear specific error
        }));
    }

    const resetForm = useCallback(() => {
        setFormData(initialFormData);
        setSelectedCountry(null);
        // setBankAcctType(null);
        setSelectedCurrency(null);
        setBanks([]);
        setUniqueFields([])
        setBanksFetched(false)
        setMethod('bank');
    }, [initialFormData, setFormData, setBanks, setUniqueFields, setBanksFetched]);

    const resetForm2 = useCallback(() => {
        // setBankAcctType(null);
        setSelectedCurrency(null);
        setBanks([]);
        setUniqueFields([]);
        setBanksFetched(false);
        setMethod('bank');

        setFormData(prev => ({
            ...prev,
            // Clear fields shown only when banksFetched is true
            account_number: '',
            bank_name: '',
            stateOrProvince: '',
            city: '',
            streetLine1: '',
            streetLine2: '',
            postalCode: '',
            ...Object.fromEntries(uniqueFields.map(f => [f, ''])) // clear dynamically rendered fields
        }));
    }, [uniqueFields, setFormData, setBanks, setUniqueFields, setBanksFetched]);

    useEffect(() => {
        let timeout;

        if (!beneficiaryBar) {
            timeout = setTimeout(() => {
                resetForm()
                resetForm2()
                setErrors({})
            }, 5200)
        }

        return () => clearTimeout(timeout);
    }, [beneficiaryBar, resetForm, resetForm2]);


    const resetCryptoForm = () => {
        setFormDataCrypto(initialFormDataCrypto);
    };

    useEffect(() => {
        if (!selectedCountry) return;

        setBanksFetched(false);
        setUniqueFields([]);
        setBanks([])
        resetForm2()
        setErrors({})
        setLoad(true)
        const token = localStorage.getItem('token');

        // country_code: selectedCountry.value,

        const params = new URLSearchParams({
            currency_code: selectedCountry.currency
        });

        const fetchBankDetails = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/banks?${params.toString()}`, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Failed to fetch bank.');
                }

                setBanks((data || []).map(bank => ({
                    value: bank.name,
                    label: bank.name,
                    code: bank.code
                })));
                setUniqueFields(data.required_fields || []);
                setBanksFetched(true);

            } catch (err) {
                console.error('Error fetching bank fields:', err);
            } finally {
                setLoad(false)
            }
        };

        fetchBankDetails();
    }, [selectedCountry, resetForm2, setBanks, setUniqueFields]);


    const createBankBeneficairy = async (e) => {
        e.preventDefault()
        const newErrors = {};
        if (!formData.full_name.trim()) {
            newErrors.full_name = "Full name is required";
        } else {
            const wordCount = formData.full_name.trim().split(/\s+/).length;
            if (wordCount < 2) {
                newErrors.full_name = "";
            }
        }

        if (!selectedCountry || !selectedCountry.value) {
            newErrors.selectedCountry = "Please select your country.";
        }

        if (!selectedCurrency || !selectedCurrency.value) {
            newErrors.selectedCurrency = "Please select your currency.";
        }
        // if (!bankAcctType || !bankAcctType.value) {
        //     newErrors.bankAcctType = "Please select your bank type.";
        // }

        uniqueFields
            .filter((field) => !hiddenFields.includes(field))
            .forEach((field) => {
                const snakeKey = extractFieldKey(field);
                if (!formData[snakeKey]?.trim()) {
                    newErrors[snakeKey] = `${generateLabel(field)} is required`;
                }
            });

        if (!formData.stateOrProvince?.trim()) {
            newErrors.stateOrProvince = "State or Province is required";
        }
        if (!formData.city?.trim()) {
            newErrors.city = "City is required";
        }
        if (!formData.streetLine1?.trim()) {
            newErrors.streetLine1 = "Street Line 1 is required";
        }
        if (!formData.bank_name) {
            newErrors.bank_name = "Please select a bank.";
        }

        if (!formData.account_number) {
            newErrors.account_number = "Please enter your account number.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);

            const firstErrorKey = Object.keys(newErrors)[0];
            const ref = fieldRefs[firstErrorKey];
            const errorRef = uniqueFieldRefs.current[firstErrorKey];

            if (ref?.current) {
                ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                ref.current.focus?.(); // Optional focus
            }
            if (errorRef?.current) {
                errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                errorRef.current.focus?.();
            }

            return;
        }

        setErrors({});

        setIsSubmitting(true);

        try {
            const token = localStorage.getItem('token')

            const payload = {
                bank_name: formData.bank_name,
                // bank_account_type: formData.bank_account_type,
                full_name: formData.full_name,
                currency: formData.currency,
                country_code: formData.country_code,
                bank_code: formData.bank_code,
                account_number: formData.account_number,
                address: {
                    countryCode: formData.countryCode,
                    stateOrProvince: formData.stateOrProvince,
                    postalCode: formData.postalCode,
                    streetLine1: formData.streetLine1,
                    streetLine2: formData.streetLine2,
                    city: formData.city,
                },
            };

            // if (Bank?.length > 0 && formData.bank_name) {
            //     payload.bank_name = formData.bank_name;
            // }

            uniqueFields.forEach((field) => {
                const snakeKey = extractFieldKey(field);
                if (snakeKey in formData) {
                    payload[snakeKey] = formData[snakeKey];
                }
            });

            console.log(payload);

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/create-local-bank`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json();

            if (!response.ok) {
                let data;
                try {
                    data = await response.json();
                    console.log('❗ Full Error Response:', data); // Debug

                    let message = '';

                    // 1. Try response.message (string)
                    if (typeof data?.response?.message === 'string') {
                        message = data.response.message;
                    }

                    // 2. Try response.message (array)
                    else if (Array.isArray(data?.response?.message)) {
                        message = data.response.message.join('\n');
                    }

                    // 3. Try top-level message
                    else if (typeof data?.message === 'string') {
                        message = data.message;
                    }

                    // 4. Fallback
                    else {
                        message = (
                            <>
                                <p>We couldn't add account.</p>
                                <p>Please recheck your inputs and try again later!</p>
                            </>
                        )
                    }

                    setErrorModal({
                        open: true,
                        message,
                    });
                    handleBeneficiaryBar()
                } catch (err) {
                    console.error('❌ Failed to parse error JSON:', err);
                    setErrorModal({
                        open: true,
                        message: (
                            <>
                                <p>We couldn't add account.</p>
                                <p>Please recheck your inputs and try again later!</p>
                            </>
                        )
                    });
                    handleBeneficiaryBar()
                }

                return;
            }
            else {
                console.log('beneficairyAdded:', data);
                window.scrollTo(0, 0)
                setOpenBenModal(true)
                resetForm()
                handleAddedBeneficiaries()
                handleBeneficiaryBar()
                fetchBeneficiaries()
            }

        } catch (error) {
            setErrorModal({
                open: true,
                message: (
                    <>
                        <p>We couldn't add account.</p>
                        <p>Please recheck your inputs and try again later!</p>
                    </>
                )
            });
            console.error('Error during Beneficairy addition:', error.message);
        } finally {
            setIsSubmitting(false);
        }
    }

    const createCryptoBeneficairy = async (e) => {
        e.preventDefault()

        const newErrors = {};

        if (!formDataCrypto.full_name.trim()) {
            newErrors.full_name = "Full name is required";
        }

        if (!formDataCrypto.wallet_address.trim()) {
            newErrors.wallet_address = "Your wallet address is required";
        }

        // if (!crypto || !crypto.value) {
        //     newErrors.crypto = "Please select your cryptocurrency type.";
        // }
        // if (!acctType || !acctType.value) {
        //     newErrors.acctType = "Please select your account type.";
        // }
        if (!networkType || !networkType.value) {
            newErrors.networkType = "Please select your blockchain.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);

            const firstErrorKey = Object.keys(newErrors)[0];
            const ref = fieldRefs[firstErrorKey];

            if (ref?.current) {
                ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                ref.current.focus?.(); // Optional focus
            }

            return;
        }

        setErrors({});

        setIsSubmitting(true);

        try {
            const token = localStorage.getItem('token')
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary/create-crypto`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formDataCrypto)
            })

            const data = await response.json();

            if (!response.ok) {
                setErrorModal({
                    open: true,
                    message: (
                        <>
                            <p>We couldn't add account.</p>
                            <p>Please recheck your inputs and try again later!</p>
                        </>
                    )
                });
                handleBeneficiaryBar()
            } else {
                console.log('CryptoBeneficairyAdded:', data);
                setOpenBenModal(true)
                window.scrollTo(0, 0)
                resetCryptoForm()
                handleAddedBeneficiaries()
                handleBeneficiaryBar()
                fetchBeneficiaries()
            }

        } catch (error) {
            console.error('Error during cryptoBeneficairy addition:', error.message);
            setErrorModal({
                open: true,
                message: (
                    <>
                        <p>We couldn't add account.</p>
                        <p>Please try again later!</p>
                    </>
                )
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    // const countryOptions = [
    //     { label: "Select Country", value: "", isDisabled: true, },
    //     { label: "USA", value: "US", currency: "USD", icon: USA, },
    //     { label: "South Africa", value: "ZA", currency: "ZAR", icon: SouthAfrica, },
    //     { label: "Nigeria", value: "NG", currency: "NGN", icon: Nigeria, },
    //     { label: "United Kingdom", value: "GB", currency: "GBP", icon: UK, },
    //     { label: "Canada", value: "CA", currency: "CAD", icon: "https://flagcdn.com/w40/ca.png", },
    //     { label: "Ghana", value: "GH", currency: "GHS", icon: "https://flagcdn.com/w40/gh.png", },
    //     { label: "Kenya", value: "KE", currency: "KES", icon: "https://flagcdn.com/w40/ke.png", },
    //     // { label: "China", value: "CN", currency: "CNY", icon: "https://flagcdn.com/w40/cn.png", },
    //     { label: "India", value: "IN", currency: "INR", icon: India, },
    //     { label: "Philippines", value: "PH", currency: "PHP", icon: Philippines, },
    //     { label: "Pakistan", value: "PK", currency: "PKR", icon: "https://flagcdn.com/w40/pk.png", },
    //     { label: "Sweden", value: "SE", currency: "SEK", icon: "https://flagcdn.com/w40/se.png", },
    //     // { label: "Switzerland", value: "CH", currency: "CHF", icon: "https://flagcdn.com/w40/ch.png", },
    // ];

    const countryOptions = [
        { label: "Select Country", value: "", isDisabled: true },

        // Uganda — UGX
        {
            label: "Uganda",
            value: "UG",
            currency: "UGX",
            icon: "https://flagcdn.com/w40/ug.png"
        },

        // Tanzania — TZS
        {
            label: "Tanzania",
            value: "TZ",
            currency: "TZS",
            icon: "https://flagcdn.com/w40/tz.png"
        },

        // Nigeria — NGN
        {
            label: "Nigeria",
            value: "NG",
            currency: "NGN",
            icon: Nigeria
        },

        // Malawi — MWK
        {
            label: "Malawi",
            value: "MW",
            currency: "MWK",
            icon: "https://flagcdn.com/w40/mw.png"
        },

        // Kenya — KES
        {
            label: "Kenya",
            value: "KE",
            currency: "KES",
            icon: "https://flagcdn.com/w40/ke.png"
        },

        // Brazil — BRL
        {
            label: "Brazil",
            value: "BR",
            currency: "BRL",
            icon: "https://flagcdn.com/w40/br.png"
        },
    ];


    // const cryptocurrencyOptions = [
    //     { label: "Cryptocurrency Type", value: "", isDisabled: true },
    //     { label: "USDT", value: "USDT" },
    //     { label: "USDC", value: "USDC" },
    //     { label: "BTC", value: "BTC" },
    //     { label: "SOL", value: "SOL" },
    //     { label: "ETH", value: "ETH" },
    //     { label: "BNB", value: "BNB" },
    // ];

    const networkOptions = [
        { label: "Blockchain", value: "", isDisabled: true },
        { label: "SOL", value: "SOL" },
        { label: "ETH", value: "ETH" },
    ];

    // const acctTypeOptions = [
    //     { label: "Account Type", value: "", isDisabled: true },
    //     { label: "Fait", value: "fait" },
    //     { label: "Crypto", value: "crypto" },
    // ];

    // const bankAcctTypeOptions = [
    //     { label: "Bank Account Type", value: "", isDisabled: true },
    //     { label: "Savings", value: "SAVING" },
    //     { label: "Checking", value: "CHECKING" },
    // ];

    const currencyOptions = Object.entries(currencyCountryMap).map(([currencyCode, countryCode]) => ({
        value: currencyCode, // this is what will be stored
        label: (
            <div className="flex items-center gap-2">
                <img
                    src={`https://flagcdn.com/w40/${countryCode}.png`}
                    alt={currencyCode}
                    className="w-[20px] h-4 rounded-sm"
                />
                {currencyCode}
            </div>
        ),
        currencyCode
    }));

    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#D2D0D6',
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '7px',
            paddingRight: '7px',
            borderRadius: '6px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderWidth: '1.2px',
            color: 'rgb(0, 0, 0, 0.6)'
        }),
        singleValue: (base) => ({
            ...base,
            color: 'rgba(0, 0, 0, 0.6)',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            padding: 10,
            cursor: 'pointer',
        }),
    };

    const customStyles2 = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#D2D0D6',
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '35px',
            paddingRight: '7px',
            borderRadius: '6px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderWidth: '1.2px',
            color: 'rgb(0, 0, 0, 0.6)'
        }),
        singleValue: (base) => ({
            ...base,
            color: 'rgba(0, 0, 0, 0.6)',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            padding: 10,
            cursor: 'pointer',
        }),
    };


    // const [bankAcctType, setBankAcctType] = useState(bankAcctTypeOptions[0])
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    // const [selectedBank, setSelectedBank] = useState(null);
    // const [crypto, setCrypto] = useState(cryptocurrencyOptions[0])
    const [networkType, setNetworkType] = useState(networkOptions[0])
    // const [acctType, setAcctType] = useState(acctTypeOptions[0])

    // const handleBankAcctType = (Option) => {
    //     setBankAcctType(Option)
    //     setFormData(prev => ({
    //         ...prev,
    //         bank_account_type: Option.value
    //     }))
    //     setErrors(prev => ({
    //         ...prev,
    //         bankAcctType: ''
    //     }));
    // }

    const handleCountries = (Option) => {
        setSelectedCountry(Option)
        setFormData(prev => ({
            ...prev,
            country_code: Option.value,
            countryCode: Option.value
        }))
        setErrors(prev => ({
            ...prev,
            selectedCountry: ''
        }));
    }

    // const handleBanks = (Option) => {
    //     setSelectedBank(Option)
    //     setFormData(prev => ({
    //         ...prev,
    //         bank_name: Option.value,
    //     }))
    //     setErrors(prev => ({
    //         ...prev,
    //         bank_name: ''
    //     }));
    // }

    const handleCurrencyChange = (selectedOption) => {
        setSelectedCurrency(selectedOption);
        setFormData(prev => ({
            ...prev,
            currency_code: selectedOption.value,
            currency: selectedOption.value,
        }))
        setErrors(prev => ({
            ...prev,
            selectedCurrency: ''
        }));
    };

    // const handleCrypto = (Option) => {
    //     setCrypto(Option)
    //     setFormDataCrypto(prev => ({
    //         ...prev,
    //         cryptocurrency_type: Option.value
    //     }))
    //     setErrors(prev => ({
    //         ...prev,
    //         crypto: ''
    //     }));
    // }
    // const handleAccountType = (Option) => {
    //     setAcctType(Option)
    //     setFormDataCrypto(prev => ({
    //         ...prev,
    //         account_type: Option.value
    //     }))
    //     setErrors(prev => ({
    //         ...prev,
    //         acctType: ''
    //     }));
    // }
    const handleNetworkType = (Option) => {
        setNetworkType(Option)
        setFormDataCrypto(prev => ({
            ...prev,
            network_type: Option.value
        }))
        setErrors(prev => ({
            ...prev,
            networkType: ''
        }));
    }

    const hiddenFields = [
        'accountHolder.address.streetLine1',
        'accountHolder.address.city',
        'accountHolder.firstName',
        'accountHolder.lastName',
    ];

    return (
        <div className={`fixed top-0 h-screen bg-white lg:p-10 py-8 px-4 duration-700 text-black z-40 overflow-auto ${beneficiaryBar ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'}`}>
            <div className='flex justify-between'>
                <div>
                    <h1 className='text-[28px] font-semibold'>Add Beneficiary Account</h1>
                    <p className='text-[14px] font-normal text-[#525154]'>No emails will be sent to your beneficiary account when you add them here - that is, unless you tell us to.</p>
                </div>
                <img
                    className='size-5 mt-1 cursor-pointer' src={close} alt=""
                    onClick={handleBeneficiaryBar}
                />
            </div>
            <div className='mt-7 flex gap-4 border-b-black/30 border-b'>
                <p
                    onClick={() => {
                        setMethod('bank')
                        setErrors({})
                    }}
                    className={method === 'bank' ? 'cursor-pointer text-[#491597] border-b-[#491597] border-b-2 pb-2 duration-700 transition-all' : 'cursor-pointer pb-2 duration-700 transition-all'}>Bank transfer</p>
                <p
                    onClick={() => {
                        setMethod('crypto')
                        setErrors({})
                    }}
                    className={method === 'crypto' ? 'cursor-pointer text-[#491597] border-b-[#491597] border-b-2 pb-2 duration-700 transition-all' : 'cursor-pointer pb-2 duration-700 transition-all'}>Cryptocurrency</p>
            </div>
            {method === 'bank' ?
                (
                    <form onSubmit={createBankBeneficairy} className='mt-7 text-[#525154] text-[14px] font-medium'>
                        <div className='mt-5'>
                            <label htmlFor="fullName">Full Name</label>
                            <div className='flex items-center mt-2 relative'>
                                <input
                                    ref={fieldRefs.full_name}
                                    className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full pl-[35px] rounded-md'
                                    type="text"
                                    name="full_name"
                                    value={formData.full_name || ''}
                                    onChange={handleBankChange}
                                    id=""

                                    placeholder='Beneficiary’s full name'
                                />
                                <img className='absolute ml-3' src={user} alt="" />
                            </div>
                            {fullNameError && (
                                <p className="text-red-500 text-sm mt-1">{fullNameError}</p>
                            )}
                            {errors.full_name && (
                                <p className="text-red-500 text-sm mt-1">{errors.full_name}</p>
                            )}
                        </div>
                        <div className='mt-5'>
                            <label htmlFor="code">Beneficiary's Country</label>
                            <div className='mt-1'>
                                <Select
                                    ref={fieldRefs.selectedCountry}
                                    styles={customStyles}
                                    options={countryOptions}
                                    getOptionLabel={(e) => (
                                        <div className="flex items-center gap-2 text-black/50">
                                            {e.icon && (
                                                <img
                                                    src={e.icon}
                                                    alt={e.label}
                                                    className="w-[20px] h-[15px] rounded-[2px]"
                                                />
                                            )}
                                            <span>{e.label}</span>
                                        </div>
                                    )}
                                    value={selectedCountry}
                                    onChange={handleCountries}

                                    isSearchable={true}
                                    className='rounded-m w-full outline-none'
                                />
                                {errors.selectedCountry && (
                                    <p className="text-red-500 text-sm mt-1">{errors.selectedCountry}</p>
                                )}
                            </div>
                        </div>
                        <p className='mt-2'>
                            {load && 'Please Wait...'}
                        </p>
                        {banks?.length > 0 && (
                            <div className="mt-4">
                                <label>Select Bank </label>
                                <div className='flex items-center mt-2 relative'>
                                    <Select
                                        ref={fieldRefs.bank_name}
                                        styles={customStyles2}
                                        options={banks}
                                        getOptionLabel={(e) => (
                                            <div className="flex items-center gap-2 text-black/50">
                                                <span>{e.label}</span>
                                            </div>
                                        )}
                                        value={banks.find(opt => opt.value === formData.bank_name) || null}
                                        onChange={handleBankChange2}
                                        isSearchable={true}
                                        className=' w-full relative outline-none'
                                    />
                                    <img className='absolute ml-3' src={Bank} alt="" />
                                </div>
                                {errors.bank_name && (
                                    <p className="text-red-500 text-sm mt-1">{errors.bank_name}</p>
                                )}
                            </div>
                        )}
                        {banksFetched && banks?.length === 0 && (
                            <div className='mt-5'>
                                <label htmlFor="fullName">Bank Name</label>
                                <div className='flex items-center mt-2 relative'>
                                    <input
                                        ref={fieldRefs.bank_name}
                                        className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full px-[14px] rounded-md'
                                        type="text"
                                        name="bank_name"
                                        value={formData.bank_name || ''}
                                        onChange={handleBankChange}
                                        id=""
                                        placeholder='Enter your bank name'
                                    />
                                </div>
                                {errors.bank_name && (
                                    <p className="text-red-500 text-sm mt-1">{errors.bank_name}</p>
                                )}
                            </div>
                        )}

                        {uniqueFields
                            .filter((field) => !hiddenFields.includes(field))
                            .map((field) => {
                                const snakeKey = extractFieldKey(field); // e.g. "nuban_code"
                                const label = generateLabel(field);      // e.g. "Nuban Code"

                                if (!uniqueFieldRefs.current[snakeKey]) {
                                    uniqueFieldRefs.current[snakeKey] = React.createRef();
                                }

                                return (
                                    <div key={field} className="mt-5">
                                        <label className="block capitalize mb-1">
                                            {label}
                                            <input
                                                ref={uniqueFieldRefs.current[snakeKey]}
                                                type="text"
                                                value={formData[snakeKey] || ''}
                                                onChange={(e) => handleChange(snakeKey, e.target.value)}
                                                className="border-[1.2px] border-[#D2D0D6] shadow-custom-light mt-2 outline-none py-[10px] w-full px-[14px] rounded-md"
                                                placeholder={`Enter your ${label}`}

                                            />
                                        </label>
                                        {errors[snakeKey] && (
                                            <p className="text-red-500 text-sm mt-1">{errors[snakeKey]}</p>
                                        )}
                                    </div>
                                );
                            })
                        }

                        {banksFetched && (
                            <>
                                {/* <div className='mt-5'>
                                    <label className='text-black/50' htmlFor="fullName">Bank account type</label>
                                    <div className='mt-1'>
                                        <Select
                                            ref={fieldRefs.bankAcctType}
                                            styles={customStyles}
                                            options={bankAcctTypeOptions}
                                            value={bankAcctType}
                                            onChange={handleBankAcctType}
                                            isSearchable={false}

                                            className='rounded-m w-full outline-none'
                                        />
                                        {errors.bankAcctType && (
                                            <p className="text-red-500 text-sm mt-1">{errors.bankAcctType}</p>
                                        )}
                                    </div>
                                </div> */}
                                <div className='mt-5'>
                                    <label htmlFor="fullName">Account Number</label>
                                    <div className='flex items-center mt-2 relative'>
                                        <input
                                            ref={fieldRefs.account_number}
                                            className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full px-[14px] rounded-md'
                                            type="text"
                                            name="account_number"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            value={formData.account_number || ''}
                                            onChange={handleBankChange}
                                            id=""
                                            placeholder='Enter your account number'
                                        />
                                    </div>
                                    {errors.account_number && (
                                        <p className="text-red-500 text-sm mt-1">{errors.account_number}</p>
                                    )}
                                </div>
                                <div className='mt-5'>
                                    <label htmlFor="code">Currency</label>
                                    <div className='flex items-center mt-2'>
                                        <Select
                                            ref={fieldRefs.selectedCurrency}
                                            styles={customStyles}
                                            options={currencyOptions}
                                            onChange={handleCurrencyChange}
                                            placeholder="Select your currency"
                                            value={selectedCurrency}
                                            className="w-full"

                                            menuPlacement="auto"
                                        />
                                    </div>
                                    {errors.selectedCurrency && (
                                        <p className="text-red-500 text-sm mt-1">{errors.selectedCurrency}</p>
                                    )}
                                </div>
                                <div className='mt-5'>
                                    <label htmlFor="code">State / Province</label>
                                    <div className='flex items-center mt-2'>
                                        <input
                                            ref={fieldRefs.stateOrProvince}
                                            className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full px-[14px] rounded-md'
                                            type="text"
                                            name="stateOrProvince"
                                            value={formData.stateOrProvince || ''}
                                            onChange={handleBankChange}
                                            id=""

                                            placeholder='Enter your state or province'
                                        />
                                    </div>
                                    {errors.stateOrProvince && (
                                        <p className="text-red-500 text-sm mt-1">{errors.stateOrProvince}</p>
                                    )}
                                </div>
                                <div className='mt-5'>
                                    <label htmlFor="code">City</label>
                                    <input
                                        ref={fieldRefs.city}
                                        className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full px-[14px] rounded-md'
                                        type="text"
                                        name="city"
                                        value={formData.city || ''}
                                        onChange={handleBankChange}
                                        id=""

                                        placeholder='Enter your city'
                                    />
                                    {errors.city && (
                                        <p className="text-red-500 text-sm mt-1">{errors.city}</p>
                                    )}
                                </div>
                                <div className='mt-5'>
                                    <label htmlFor="code">Street Line 1</label>
                                    <input
                                        ref={fieldRefs.streetLine1}
                                        className='border-[1.2px] mt-2 border-black/20 rounded-md w-full py-[10px] px-[14px] outline-none'
                                        type="text"
                                        name="streetLine1"
                                        value={formData.streetLine1}
                                        onChange={handleBankChange}
                                        maxLength={35}
                                        placeholder='564866'
                                    />
                                    {errors.streetLine1 && (
                                        <p className="text-red-500 text-sm mt-1">{errors.streetLine1}</p>
                                    )}
                                </div>
                                <div className='mt-5'>
                                    <label htmlFor="code">Street Line 2</label>
                                    <input
                                        className='border-[1.2px] mt-2 border-black/20 rounded-md w-full py-[10px] px-[14px] outline-none'
                                        type="text"
                                        name="streetLine2"
                                        value={formData.streetLine2}
                                        onChange={handleBankChange}
                                        id=""
                                        placeholder='564866'
                                    />
                                    <p className='mt-1 text-black/40'>(Optional)</p>
                                </div>
                                <div className='mt-5'>
                                    <label htmlFor="code">Zip / postal code</label>
                                    <input
                                        className='border-[1.2px] mt-2 border-black/20 rounded-md w-full py-[10px] px-[14px] outline-none'
                                        type="number"
                                        name="postalCode"
                                        value={formData.postalCode}
                                        onChange={handleBankChange}
                                        id=""
                                        placeholder='564866'
                                    />
                                    <p className='mt-1 text-black/40'>(Optional)</p>
                                </div>
                            </>
                        )}
                        <div className='flex gap-4 mt-10'>
                            <button
                                className='p-3 rounded-lg w-[25%] border-[1.2px] border-black/10'
                                onClick={() => {
                                    handleBeneficiaryBar()
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className={`p-[10px] px-4 rounded-lg text-white w-[80%] ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    'Loading...'
                                ) : (
                                    'Save information'
                                )}
                            </button>
                        </div>
                    </form>
                ) : (
                    <form onSubmit={createCryptoBeneficairy} className='mt-7 text-[#525154] text-[14px] font-medium'>
                        <div className='mt-5 text-black/60'>
                            <label className='text-black/60' htmlFor="fullName">Full Name</label>
                            <div className='flex items-center mt-2 relative'>
                                <input
                                    ref={fieldRefs.full_name}
                                    className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full pl-[35px] rounded-md'
                                    type="text"
                                    name="full_name"
                                    value={formDataCrypto.full_name || ''}
                                    onChange={handleCryptoChange}
                                    id=""

                                    placeholder='Beneficiary’s full name'
                                />
                                <img className='absolute ml-3' src={user} alt="" />
                            </div>
                            {errors.full_name && (
                                <p className="text-red-500 text-sm mt-1">{errors.full_name}</p>
                            )}
                        </div>
                        {/* <div className='mt-5'>
                            <label className='text-black/50' htmlFor="code">Cryptocurrency type</label>
                            <div className='mt-1'>
                                <Select
                                    ref={fieldRefs.crypto}
                                    styles={customStyles}
                                    options={cryptocurrencyOptions}
                                    value={crypto}
                                    onChange={handleCrypto}
                                    isSearchable={false}
                                    className='rounded-m w-full outline-none'
                                />
                                {errors.crypto && (
                                    <p className="text-red-500 text-sm mt-1">{errors.crypto}</p>
                                )}
                            </div>
                        </div> */}
                        <div className='mt-5'>
                            <label className='text-black/50' htmlFor="fullName">Wallet address</label>
                            <div className='flex items-center mt-2'>
                                <input
                                    ref={fieldRefs.wallet_address}
                                    className='border-[1.2px] border-[#D2D0D6] shadow-custom-light outline-none py-[10px] w-full px-[14px] rounded-md'
                                    type="text"
                                    name="wallet_address"
                                    value={formDataCrypto.wallet_address || ''}
                                    onChange={handleCryptoChange}
                                    id=""
                                    placeholder='Wallet address'
                                />
                            </div>
                            {errors.wallet_address && (
                                <p className="text-red-500 text-sm mt-1">{errors.wallet_address}</p>
                            )}
                        </div>
                        {/* <div className='mt-5'>
                            <label className='text-black/50' htmlFor="fullName">Account type</label>
                            <div className='mt-1'>
                                <Select
                                    ref={fieldRefs.acctType}
                                    styles={customStyles}
                                    options={acctTypeOptions}
                                    value={acctType}
                                    onChange={handleAccountType}
                                    isSearchable={false}

                                    className='rounded-m w-full outline-none'
                                />
                                {errors.acctType && (
                                    <p className="text-red-500 text-sm mt-1">{errors.acctType}</p>
                                )}
                            </div>
                        </div> */}
                        <div className='mt-5'>
                            <label className='text-black/50' htmlFor="code">Blockchain</label>
                            <div className='mt-1'>
                                <Select
                                    ref={fieldRefs.networkType}
                                    styles={customStyles}
                                    options={networkOptions}
                                    value={networkType}
                                    onChange={handleNetworkType}
                                    isSearchable={false}
                                    className='rounded-m w-full outline-none'
                                />
                                {errors.networkType && (
                                    <p className="text-red-500 text-sm mt-1">{errors.networkType}</p>
                                )}
                            </div>
                        </div>
                        <div className='flex gap-4 mt-12'>
                            <button
                                className='p-3 rounded-lg w-[25%] border-[1.2px] border-black/10'
                                onClick={handleBeneficiaryBar}
                            >
                                Cancel
                            </button>
                            <button
                                className={`p-[10px] px-4 rounded-lg text-white w-[80%] ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    'Loading...'
                                ) : (
                                    'Save information'
                                )}
                            </button>
                        </div>
                    </form>
                )}


            {/* <BeneficiaryModal openBenModal={openBenModal} setOpenBenModal={setOpenBenModal} errorModal={errorModal} setErrorModal={setErrorModal} /> */}
        </div>
    )
}

export default BeneficiaryBar